import React from "react";
import "react-sweet-progress/lib/style.css";

// import hero from '../../assets/hero1.jpg'

const About = () => {
    return (
        <div className="mt-28 mb-20 mx-auto">
            <div className="text-center">
                <h2 className="font-extrabold uppercase text-4xl dark:text-[#E9F8F9]">
                    About Me
                </h2>
                <p className="dark:text-[#E9F8F9]">
                    ./ <span className="underline">about</span>|
                </p>
            </div>

            <div className="mt-24 px-2 md:px-6 w-[90%] lg:w-3/4 mx-auto">
                <h2 className="font-bold text-xl dark:text-[#E9F8F9]">
                    About Information
                </h2>
                {/* Profile Information */}
                <div className="mt-5 md:mt-8 flex justify-center items-center md:items-start flex-col md:flex-row">
                    {/* <div className="md:mr-5">
                        <img
                            className="w-[150px] md:w-[200px] rounded-full"
                            src={hero}
                            alt=""
                        />
                    </div> */}
                    <div className="mt-5 md:mt-0">
                        <p className="font-medium text-justify dark:text-[#E9F8F9]">
                            Hi! I am Nabil Ahmed Nahid form Dhaka, Bangladesh. I
                            am Learning Programming every single day. I have
                            some projects with React Js and WordPress. I am a hard working person. I always learn new technologies everyday.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-5 place-items-center md:place-items-start mt-8 md:mt-16 text-sm">
                            <p className="pb-2">
                                <span className="text-[#98A8F8] font-bold text-base">
                                    Age:
                                </span>{" "}
                                <span className="dark:text-[#E9F8F9]">24</span>
                            </p>
                            <p className="pb-2">
                                <span className="text-[#98A8F8] font-bold text-base">
                                    Address:
                                </span>{" "}
                                <span className="dark:text-[#E9F8F9]">
                                    Dhaka, Bangladesh
                                </span>
                            </p>
                            <p className="pb-2">
                                <span className="text-[#98A8F8] font-bold text-base">
                                    Email:
                                </span>{" "}
                                <span className="dark:text-[#E9F8F9]">
                                    nabilahmednahid@gmail.com
                                </span>
                            </p>

                            <p className="pb-2">
                                <span className="text-[#98A8F8] font-bold text-base">
                                    Phone:
                                </span>{" "}
                                <span className="dark:text-[#E9F8F9]">
                                    +8801820861115
                                </span>
                            </p>
                        </div>

                        {/* <button className="px-4 mt-4 py-2 block mx-auto md:mx-0 bg-gradient-to-r from-green-400 to-blue-500 text-white">
                            <a href="https://drive.google.com/file/d/1mml-5tbGmERS65eaqPaRmj8-_e1sMJl1/view?usp=share_link">
                                Download Resume
                            </a>
                        </button> */}
                    </div>
                </div>

                {/* Education */}
                <div className="mt-16 ">
                    
                    <h2 className="font-bold text-xl dark:text-[#E9F8F9]">
                        Education
                    </h2>
                    <div className="mt-6">
                        <div>
                            <p className="border-2 border-[#98A8F8] px-2 py-1 text-sm w-fit dark:text-[#E9F8F9]">
                                2019 - 2023 Jan 
                            </p>
                            <h4 className="text-sm font-bold mt-3 dark:text-[#E9F8F9]">
                                Daffodil International University
                            </h4>
                            <h2 className="text-sm mt-2 dark:text-[#E9F8F9]">BSc in CSE</h2>
                            <p className="text-sm mt-2 dark:text-[#E9F8F9]">
                                Result : CGPA 3.37 Out of 4.00
                            </p>
                        </div>

                        <div className="mt-5">
                            <p className="border-2 border-[#98A8F8] px-2 py-1 text-sm w-fit dark:text-[#E9F8F9]">
                                2016 - 2018
                            </p>
                            <h4 className="text-sm font-bold mt-3 dark:text-[#E9F8F9]">
                                Demra Ideal College
                            </h4>
                            <p className="text-sm mt-2 dark:text-[#E9F8F9]">Group: Science</p>
                            <p className="text-sm mt-2 dark:text-[#E9F8F9]">
                                GPA 4.75 Out of 5.00{" "}
                            </p>
                        </div>
                        <div className="mt-5">
                            <p className="border-2 border-[#98A8F8] px-2 py-1 text-sm w-fit dark:text-[#E9F8F9]">
                                2016
                            </p>
                            <h4 className="text-sm font-bold mt-3 dark:text-[#E9F8F9]">
                                Titas Gas Adarsha High School
                            </h4>
                            <p className="text-sm mt-2 dark:text-[#E9F8F9]">Group: Science</p>
                            <p className="text-sm mt-2 dark:text-[#E9F8F9]">
                                GPA 4.61 Out of 5.00{" "}
                            </p>
                        </div>

                        {/* <div className="mt-5">
                            <p className="border-2 border-[#98A8F8] px-2 py-1 text-sm w-fit">
                                June 2022 - Dec 2022
                            </p>
                            <h4 className="text-sm font-bold mt-3">
                                Complete Web Development Course - Programming
                                Hero
                            </h4>
                            <p className="text-sm mt-2">
                                I have done this course and complete almost 25+{" "}
                                <br /> projects where there is 4 Full Stack
                                projects.
                            </p>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
